import '../left-menu';
import '../side-panel';
import {until} from 'lit-html/directives/until';

export default (ctx, html) => {
  if (ctx.loadZendeskWidget || ctx.loadAdaWidget) {
    return html``;
  }
  return html`
    <div class="${ctx.showForm ? 'button-none' : 'button-show'}">
      <button type="submit" class="btn btn-lg btn-block btn-primary rounded-pill" @click="${ctx.showSupportForm}">
        <img class="mr-2" src="${require('./images/support-widget-question-mark.webp')}"/>
        <span>${until(ctx.__('<tt-mtkJYlFN>', 'Support'))}</span>
      </button>
    </div>
    <div class="${ctx.showForm ? 'support-form-show' : 'support-form-none'}">
      <div class="header d-flex">
        <span class="flex-grow-1">${until(ctx.__('<tt-ibfCUJI6>', 'Contact us'))}</span>
        <button type="button" class="close" aria-label="Close" @click="${ctx.closeSupportForm}">
          <img src="${require('./images/support-widget-close-form-button.webp')}"/>
        </button>
      </div>
      <div class="body mx-5 my-4">
        ${until(ctx.getOrgMessage(ctx.orgRootId))}
      </div>
    </div>
  `;
}
